import Vue from 'vue';
import VueRouter from 'vue-router';
import firebasePlugin from '@/plugins/firebase';

const Dashboard = () => import('@/views/Dashboard.vue');
const Signin = () => import('@/views/Signin.vue');
const Profile = () => import('@/views/Profile.vue');
const Schedule = () => import('@/views/Schedule.vue');
const PageNotFound = () => import('@/views/PageNotFound');

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
    },
    {
        path: '/schedule',
        name: 'Schedule',
        component: Schedule,
    },
    {
        path: '/signin',
        name: 'Signin',
        component: Signin,
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
    },
    {
        path: '*',
        component: PageNotFound,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    // Signin page does not check permission
    if (to.name === 'Signin') {
        next();
        return;
    }

    firebasePlugin
        .authUser()
        .then(() => {
            next();
        })
        .catch(() => {
            next('/signin');
        });
});

export default router;
